export const creativeGroups = {
  COMMON: "common",
  DEFAULT: "default",
};

export const sitesGroups = [
  creativeGroups.DEFAULT,
];